import { Component, Input } from '@angular/core';
import { PrimeIcons } from 'primeng/api';

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',

})
export class PanelComponent {


  @Input() header: string = '';
  @Input() canToggle: boolean = true;
  @Input() isCollapsed:  boolean = true;
  @Input()expandIcon: string = 'pi pi-chevron-up'
  @Input()collapseIcon: string = 'pi pi-chevron-down'

}
